export enum ScoreNames {
    DECREASED = 'Decreased',
    AVERAGE = 'Average',
    INCREASED = 'Increased',
    LOCKED = 'Due to insufficient number of SNPs we were not able to calculate your genetic score',
}
